import type { UseQueryResult } from '@tanstack/react-query';

import type { RegionDetail } from '../../../../api/regions';
import { BucketError, SectionCard } from '../../regional/BucketStates';

import { RegionDetailBody } from './RegionDetailBody';

interface Props {
  selectedId: string | null;
  query: UseQueryResult<RegionDetail>;
  colorMap: Map<string, string>;
}

/** Selected-region detail panel for the Region Management landing. */
export function RegionDetailCard({ selectedId, query, colorMap }: Props) {
  const detail = query.data;
  let body: React.ReactNode;

  if (!selectedId) {
    body = (
      <div style={{ fontSize: 13, color: 'var(--nb-subtle)' }}>
        Select a region to see its detail.
      </div>
    );
  } else if (query.isLoading) {
    body = <div style={{ fontSize: 13, color: 'var(--nb-subtle)' }}>Loading…</div>;
  } else if (!detail) {
    body = <BucketError error={query.error} />;
  } else {
    body = <RegionDetailBody detail={detail} colorMap={colorMap} />;
  }

  return <SectionCard title="Detail">{body}</SectionCard>;
}
